import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimplebarAngularModule } from 'simplebar-angular';
import WordSearchPuzzleWord from '../interfaces/word-search-puzzle-word';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'lib-app-word-search-puzzle-word-list',
  templateUrl: './word-search-puzzle-word-list.component.html',
  styleUrls: ['./word-search-puzzle-word-list.component.scss'],
  standalone: true,
  imports: [CommonModule, SimplebarAngularModule],
  animations: [
    trigger('inOutAnimation', [
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('0.5s 0.5s linear', style({ height: 22, opacity: 1 })),
      ]),
    ]),
  ],
})
export class WordSearchPuzzleWordListComponent {
  @Input() wordList: WordSearchPuzzleWord[];
  @Input() foundWords: WordSearchPuzzleWord[];
  @Input() horizontal = false;
  @Input() maxVerticalHeight: number;
  @Input() maxHorizontalWidth: number;

  wordIsFound(currentWord: WordSearchPuzzleWord): boolean {
    return this.foundWords.filter((word) => word.text === currentWord.text).length !== 0;
  }
}
